const HomeSite = require("@/modules/home/components/HomeSite").default;
const DashboardSite = require("@/modules/home/components/DashboardSite.vue")
  .default;
const NewsSite = require("@/modules/home/components/NewsSite.vue").default;
const NewsDetailSite = require("@/modules/home/components/NewsDetailSite")
  .default;
const SingleNewsSite = require("@/modules/home/components/SingleNewsSite")
  .default;

const HomeRoutes = [
  {
    name: "Home Base",
    path: "/home/",
    component: HomeSite,
    redirect: "/home/dashboard",
    children: [
      {
        name: "Dashboard",
        path: "/home/dashboard/",
        component: DashboardSite,
        meta: {
          requiresAuth: true,
        },
      },
      {
        name: "News",
        path: "/home/news/",
        component: NewsSite,
        meta: {
          requiresAuth: true,
        },
      },
      {
        name: "News Detail",
        path: "/home/news/:id",
        components: { default: NewsDetailSite },
        props: { default: true },
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
  {
    name: "Single news",
    path: "/single-news/:id",
    components: { default: SingleNewsSite },
    props: { default: true },
    meta: {
      requiresAuth: false,
      header: false,
      footer: false,
    },
  },
];

const HomeSettingsRoutes = [];

const HomeBaseDataRoutes = [];

export { HomeRoutes, HomeSettingsRoutes, HomeBaseDataRoutes };
